import { render, staticRenderFns } from "./AvatarStatusImportacaoPedido.vue?vue&type=template&id=29a7763c&"
import script from "./AvatarStatusImportacaoPedido.vue?vue&type=script&lang=js&"
export * from "./AvatarStatusImportacaoPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports